/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminRefundAccountResponseDto } from '../../models/admin-refund-account-response-dto';

export interface OrderControllerGetRefundAccountByOrder$Params {

/**
 * 주문 ID
 */
  id: string;
}

export function orderControllerGetRefundAccountByOrder(http: HttpClient, rootUrl: string, params: OrderControllerGetRefundAccountByOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminRefundAccountResponseDto>> {
  const rb = new RequestBuilder(rootUrl, orderControllerGetRefundAccountByOrder.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminRefundAccountResponseDto>;
    })
  );
}

orderControllerGetRefundAccountByOrder.PATH = '/api/orders/{id}/refund-account';
